// O backend devolve regras de negócio como {message} e erros de leitura do JSON como
// application/problem+json ({detail}); nenhum dos dois traz lista de erros por campo.
export function mensagemErroApi(error: any, padrao: string = 'Erro inesperado'): string {
  return error?.error?.message ?? error?.error?.detail ?? padrao;
}
